import { render, staticRenderFns } from "./user-admin-edit-new.vue?vue&type=template&id=b8eb29f6&"
import script from "./user-admin-edit-new.vue?vue&type=script&lang=js&"
export * from "./user-admin-edit-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports